import { render, staticRenderFns } from "./StockItemMerchandise.vue?vue&type=template&id=2c825150"
import script from "./StockItemMerchandise.vue?vue&type=script&lang=js"
export * from "./StockItemMerchandise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c825150')) {
      api.createRecord('2c825150', component.options)
    } else {
      api.reload('2c825150', component.options)
    }
    module.hot.accept("./StockItemMerchandise.vue?vue&type=template&id=2c825150", function () {
      api.rerender('2c825150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/StockItemMerchandise.vue"
export default component.exports